import { createStore } from "solid-js/store";

// Optimistic toggle state is held at module scope so it survives the frequent
// remounts virtualization causes and stays shared across every TodoItem part.
export const OPTIMISTIC_TIMEOUT_MS = 5000;
export const VISUAL_DELAY_MS = 15;

export const [optimisticCompleted, setOptimisticCompleted] = createStore<
  Record<string, boolean | undefined>
>({});
export const [optimisticImportant, setOptimisticImportant] = createStore<
  Record<string, boolean | undefined>
>({});
